import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash.get";
import { getAuthStatus } from "../../helper/datalayer-utils";

import Feature1 from "./feature1";
import Feature2 from "./feature2";
import Feature3 from "./feature3";
import Bull from "./bull";
import Exit from "./exit"
import BigBull from "./bigBull"

import "./paywall-card.m.css";

const PaywallCard = ({ story }) => {
  const isLoggedIn = useSelector((state) => get(state, ["isLogin"], false));
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const [paywallData, setPaywallData] = useState([]);
  const [redirectURL, setRedirectUrl] = useState("");
  const signinHandler = () => {
    if (window) {
      console.log("DataLayer SSO_Page_Open Event (paywall)");
      window.dataLayer.push({
        event: "SSO_Page_Open"
      });
      sessionStorage.setItem("sso_login_initiated_source", "paywall");
      localStorage.removeItem("last_logged_in_uuid");
    }
    setTimeout(() => {
      window.location.assign(`${ssoEndpoint}/auth?redirectUrl=${encodeURIComponent(redirectURL)}`);
    }, 300);
  };

  useEffect(() => {
    setRedirectUrl(window.location.href);
    const fetchPaywallData = async () => {
      try {
        const response = await fetch("/subscription-paywall");
        const data = await response.json();
        setPaywallData(data);
      } catch (error) {
        console.error("Error fetching paywall data:", error);
        setPaywallData(false);
      }
    };

    fetchPaywallData();
  }, []);

  useEffect(() => {
    if (!paywallData || typeof window === "undefined" || typeof IntersectionObserver === "undefined") return;
    
    const paywallEl = document.getElementById("paywall-impression-target");
    if (!paywallEl) return;
    
    let hasTracked = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !hasTracked) {
          hasTracked = true;
          const { status, uuid } = getAuthStatus();
          const formattedStatus = status === "not_logged_in" ? "non_logged_in" : status;
          
          const articleId = story?.["public-identifier"] || "NA";
          const sectionName = story?.sections?.length > 0 ? story.sections.map((s) => s.name).join(",") : "NA";

          const eventPayload = {
            event: "paywall_impression",
            auth_status: formattedStatus,
            page_path: decodeURI(window.location.pathname),
            article_id: articleId,
            section_name: sectionName
          };

          if (uuid !== "NA") {
            eventPayload.uuid = uuid;
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(eventPayload);
        }
      });
    }, { threshold: 0.75 });

    observer.observe(paywallEl);

    return () => {
      observer.disconnect();
    };
  }, [paywallData]);

  if (!paywallData) {
    return <div>paywall...</div>;
    // return null;
  }

  return (
    <div>
      <div styleName="paywall-opacity-layer"></div>
      <div styleName="paywall-wrapper" id="paywall-impression-target">
        <div styleName="paywall-heading">{paywallData?.title}</div>
        <div styleName="paywall-subHeading">{paywallData?.subHeading}</div>
        <div styleName="paywall-features">
          <div styleName="bigBull"><BigBull /></div>
          <div styleName="feature-container feature1-container">
            <Feature1 />
            <span styleName="feature-text feature1">{paywallData?.feature1}</span>
          </div>
          <div styleName="feature-container feature2-container">
            <Feature2 />
            <span styleName="feature-text">{paywallData?.feature2}</span>
          </div>
          <div styleName="feature-container feature3-container">
            <Feature3 />
            <span styleName="feature-text feature3">{paywallData?.feature3}</span>
          </div>
        </div>
        <a 
          styleName="paywall-cta-button" 
          href="/subscribe"
          onClick={() => {
            if (window) {
              sessionStorage.setItem("subscribe_source", "paywall");
              const { status, uuid } = getAuthStatus();
              const formattedStatus = status === "not_logged_in" ? "non_logged_in" : status;
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "paywall_subscribe_button_click",
                auth_status: formattedStatus,
                uuid: uuid,
                page_url: decodeURI(window.location.href)
              });
            }
          }}
        >
          <Bull />
          <span styleName="button-text">{paywallData?.ctaSubscribeText}</span>
        </a>
        {!isLoggedIn && (
          <div styleName="paywall-bottom">
            <span>{paywallData?.ctaBottomText1}</span>
            <div styleName="login-action" onClick={() => signinHandler()}>
              <span styleName="login-text">{paywallData?.ctaBottomText2}</span>
              <span style={{ paddingTop: "3px" }}>
                <Exit />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaywallCard;
